import api from '../api'

export default {
  paypal: {
    createRequest(payload) {
      return new Promise((resolve, reject) => {
        print('Supposed to create request', payload)
        
        console.log(api, resolve, reject)
      })
    }
  }
}
